import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './file-list-filter-year.component.scss';
var FileListFilterYear = /** @class */ (function (_super) {
    tslib_1.__extends(FileListFilterYear, _super);
    function FileListFilterYear(element) {
        return _super.call(this, element) || this;
    }
    FileListFilterYear.prototype.init = function () {
        this.selectSort = this.element.querySelector('.js-select-sort');
        this.selectBox = this.element.querySelector('.file-list-filter-year__sort__form__select--box');
        this.selectBoxSort = Array.from(this.element.querySelectorAll('.file-list-filter-year__sort__form__select--box__button'));
        this.selectBoxSortItem = Array.from(this.element.querySelectorAll('.file-list-filter-year__sort__form__select--box__item'));
        this.selectDate = this.element.querySelector('.js-select-date');
        this.selectBox = this.element.querySelector('.file-list-filter-year__date__form__select--box');
        this.selectBoxDate = Array.from(this.element.querySelectorAll('.file-list-filter-year__date__form__select--box__button'));
        this.selectBoxDateItem = Array.from(this.element.querySelectorAll('.file-list-filter-year__date__form__select--box__item'));
    };
    FileListFilterYear.prototype.changeSort = function (value) {
        console.log(value);
    };
    FileListFilterYear.prototype.changeDate = function (value) {
        console.log(value);
    };
    FileListFilterYear.prototype.bindEvents = function () {
        var _this = this;
        // desktop button
        this.selectBoxSort.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.currentTarget;
            var parent = element.closest('.file-list-filter-year__sort__form__select__desktop-container');
            var box = parent.querySelector('.file-list-filter-year__sort__form__select--box');
            if (box.classList.contains('file-list-filter-year__sort__form__select--box__active')) {
                box.classList.remove('file-list-filter-year__sort__form__select--box__active');
            }
            else {
                box.classList.add('file-list-filter-year__sort__form__select--box__active');
            }
        }); });
        // desktop select
        this.selectBoxSortItem.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            var dataName = element.getAttribute('data-name');
            var dataValue = element.getAttribute('data-value');
            var i;
            var parent = element.closest('.file-list-filter-year__sort__form__select');
            var select = parent.querySelector('select');
            for (i = 0; i < select.length; i++) {
                if (select[i].value === dataValue) {
                    break;
                }
            }
            select.options.selectedIndex = i;
            var container = element.closest('.file-list-filter-year__sort__form__select__desktop-container');
            var button = container.querySelector('.file-list-filter-year__sort__form__select--box__button');
            var box = container.querySelector('.file-list-filter-year__sort__form__select--box');
            box.classList.remove('file-list-filter-year__sort__form__select--box__active');
            button.innerHTML = dataName;
            _this.changeSort(select.value);
        }); });
        // desktop button date
        this.selectBoxDate.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.currentTarget;
            if (_this.selectBox.classList.contains('file-list-filter-year__date__form__select--box__active')) {
                _this.selectBox.classList.remove('file-list-filter-year__date__form__select--box__active');
            }
            else {
                _this.selectBox.classList.add('file-list-filter-year__date__form__select--box__active');
            }
        }); });
        // desktop select
        this.selectBoxDateItem.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            var dataName = element.getAttribute('data-name');
            var dataValue = element.getAttribute('data-value');
            var i;
            var parent = element.closest('.file-list-filter-year__date__form__select');
            var select = parent.querySelector('select');
            for (i = 0; i < select.length; i++) {
                if (select[i].value === dataValue) {
                    break;
                }
            }
            select.options.selectedIndex = i;
            var container = element.closest('.file-list-filter-year__date__form__select__desktop-container');
            var button = container.querySelector('.file-list-filter-year__date__form__select--box__button');
            _this.selectBox.classList.remove('file-list-filter-year__date__form__select--box__active');
            button.innerHTML = dataName;
            _this.changeDate(select.value);
        }); });
    };
    return FileListFilterYear;
}(Base));
export { FileListFilterYear };



//////////////////
// WEBPACK FOOTER
// ./components/file-list-filter-year/file-list-filter-year.component.ts
// module id = 288
// module chunks = 0